<!--
Copyright 2020 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <a v-if="disabledTitle == null" class="enketo-preview btn btn-primary"
    :href="href" target="_blank">
    <span class="icon-eye"></span>{{ $t('action.preview') }}
  </a>
  <button v-else type="button" class="enketo-preview btn btn-primary" disabled
    :title="disabledTitle">
    <span class="icon-eye"></span>{{ $t('action.preview') }}
  </button>
</template>

<script>
import Form from '../../presenters/form';
import { enketoBasePath } from '../../util/util';

export default {
  name: 'EnketoPreview',
  props: {
    formVersion: {
      type: Form,
      required: true
    }
  },
  computed: {
    disabledTitle() {
      if (this.formVersion.publishedAt != null &&
        this.formVersion.state !== 'open')
        return this.$t('disabled.notOpen');
      if (this.formVersion.enketoId == null)
        return this.$t('disabled.processing');
      return null;
    },
    href() {
      // enketoId probably doesn't need to be encoded, but there is also little
      // harm.
      const encodedId = encodeURIComponent(this.formVersion.enketoId);
      return `${enketoBasePath}/preview/${encodedId}`;
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    "action": {
      "preview": "Preview"
    },
    "disabled": {
      "processing": "Preview has not finished processing for this Form. Please refresh later and try again.",
      "notOpen": "In this version of ODK Central, preview is only available for Forms in the Open state."
    }
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "action": {
      "preview": "Náhled"
    },
    "disabled": {
      "processing": "Náhled nedokončil zpracování tohoto formuláře. Aktualizujte prosím později a zkuste to znovu.",
      "notOpen": "V této verzi ODK Central je náhled k dispozici pouze pro formuláře v otevřeném stavu."
    }
  },
  "de": {
    "action": {
      "preview": "Vorschau"
    },
    "disabled": {
      "processing": "Die Vorschau für dieses Formular ist noch nicht vollständig erstellt. Bitte aktualieren Sie und versuchen Sie es später noch einmal.",
      "notOpen": "In dieser Version von ODK Central steht die Vorschau nur für Formule im Zustand \"Offen\" zur Verfügung."
    }
  },
  "es": {
    "action": {
      "preview": "Vista previa"
    },
    "disabled": {
      "processing": "La vista previa no ha finalizado el procesamiento de este formulario. Por favor actualice más tarde e intente nuevamente.",
      "notOpen": "En esta versión de ODK Central, la vista previa solo está disponible para formularios en estado abierto."
    }
  },
  "fr": {
    "action": {
      "preview": "Prévisualiser"
    },
    "disabled": {
      "processing": "L'aperçu n'a pas fini d'être exécuté pour ce formulaire. Veuillez rafraîchir plus tard et réessayer.",
      "notOpen": "Dans cette version d'ODK Central, l'aperçu n'est disponible que pour les formulaires dont l'état est ouvert."
    }
  }
}
</i18n>
